import { Route } from '@angular/router';
import { RoutingNames } from 'shared';

export const authenticationRoutes: Route[] = [
  {
    path: RoutingNames.login,
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    title: 'Inloggen',
  },
  {
    path: RoutingNames.loginOtp,
    loadComponent: () => import('./otp/otp.component').then((m) => m.OtpComponent),
    title: 'Inloggen',
  },
  {
    path: RoutingNames.changePassword,
    loadComponent: () =>
      import('./change-password-page/change-password-page.component').then((m) => m.ChangePasswordPageComponent),
    title: 'Wachtwoord wijzigen',
  },
  {
    path: RoutingNames.setPasswordRequestConfirmation,
    loadComponent: () =>
      import('./request-password-set-confirmation-page/request-password-set-confirmation-page.component').then(
        (m) => m.RequestPasswordSetConfirmationPageComponent,
      ),
    title: 'Wachtwoord opnieuw ingesteld',
  },
  {
    path: RoutingNames.resetPasswordRequest,
    loadComponent: () =>
      import('./request-password-reset-page/request-password-reset-page.component').then(
        (m) => m.RequestPasswordResetPageComponent,
      ),
    title: 'Wachtwoord opnieuw instellen',
  },
  {
    path: RoutingNames.passwordReset,
    loadComponent: () =>
      import('./reset-password-page/reset-password-page.component').then((m) => m.ResetPasswordPageComponent),
    title: 'Wachtwoord opnieuw instellen',
  },
  {
    path: RoutingNames.passwordSet,
    loadComponent: () =>
      import('./set-password-page/set-password-page.component').then((m) => m.SetPasswordPageComponent),
    title: 'Wachtwoord opnieuw instellen',
  },
];
